module.exports = "/img/_/_/_/assets/images//button.png?a31d90773cf927d073d03d2cb85398f4";